import { Dispatch, SetStateAction, useCallback, useState } from "react";

/**
 * useState s objektovym stavem + pomocne funkce.
 * updateState/toggleState maji stabilni identitu (useCallback s []) - React setState je stabilni a pouzivame
 * funkcionalni updater, takze nepotrebuji zadne zavislosti. Diky tomu je lze predavat do memo() komponent
 * a davat do dependency listu, aniz by se efekty/rendery spoustely zbytecne.
 */
export function myUseState<T>(initState: T | (() => T)): {
	state: T;
	setState: Dispatch<SetStateAction<T>>;
	updateState: (changes: Partial<T>) => void;
	toggleState: (name: keyof T) => void;
} {
	const [state, setState] = useState<T>(initState);

	const updateState = useCallback((changes: Partial<T>): void => {
		setState(prev => {
			// beze zmeny vratime puvodni objekt -> React preskoci render
			const changed = Object.keys(changes).some(key => !Object.is(prev[key as keyof T], changes[key as keyof T]));

			return changed
				? { ...prev, ...changes }
				: prev;
		});
	}, []);

	const toggleState = useCallback((name: keyof T) => {
		setState(prev => ({
			...prev,
			[name]: !(prev[name] as boolean),
		}));
	}, []);

	return {
		state,
		setState,
		updateState,
		toggleState,
	};
}
